export const qusAnsSelectionLisiting_style = {
  rootSx: {
    pt: 1.25,
  },
};
